import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserCard, listUserGames, resetGames } from "../../store/actions";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  Avatar,
  Paper,
  IconButton,
  Divider,
  LinearProgress,
  Tooltip,
  Badge,
  Button,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import {
  SportsEsports,
  People,
  CalendarToday,
  Update,
  CheckCircle,
  Schedule,
  Cancel,
  Refresh,
  GamepadOutlined,
  EmojiEvents,
  Close,
  ViewModule,
  FormatListNumbered,
} from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

const UserGames = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const user = useSelector((state) => state.userProfile.profile);
  const gamesData = useSelector((state) => state.userProfile.games);
  const loading = useSelector((state) => state.loading);
  const cards = useSelector((state) => state.userProfile.cards);

  console.log(cards);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedGameCard, setSelectedGameCard] = useState(null);
  const [selectedGameId, setSelectedGameId] = useState(null);

  useEffect(() => {
    dispatch(resetGames());
    if (user?.id) {
      dispatch(listUserGames(user.id));
    }
  }, [dispatch, user?.id]);

  const gamesList = gamesData?.list || [];
  const totalGames = gamesList.length;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return colors.greenAccent[500];
      case "ongoing":
      case "active":
        return colors.blueAccent[500];
      case "cancelled":
      case "canceled":
        return colors.redAccent[500];
      case "pending":
        return colors.yellowAccent[500];
      default:
        return colors.grey[500];
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return <CheckCircle />;
      case "ongoing":
      case "active":
        return <Schedule />;
      case "cancelled":
      case "canceled":
        return <Cancel />;
      case "pending":
        return <Update />;
      default:
        return <SportsEsports />;
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return "Invalid Date";
    }
  };

  useEffect(() => {
    if (selectedGameId && cards[selectedGameId]) {
      setSelectedGameCard({
        game: { _id: selectedGameId },
        card: cards[selectedGameId],
      });
      setModalOpen(true);
    }
  }, [cards, selectedGameId]);

  const handleViewCard = (e, game) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(fetchUserCard(user.username, game._id));
    setSelectedGameId(game._id);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedGameCard(null);
  };

  const BingoCard = ({ card, gameInfo }) => {
  const headers = ["B", "I", "N", "G", "O"];

  return (
    <div
      style={{
        background: `linear-gradient(135deg, #4a5568 0%, #2d3748 100%)`,
        borderRadius: "20px",
        padding: "24px",
        maxWidth: "500px",
        margin: "0 auto",
      }}
    >
      <h2
        style={{
          color: "white",
          fontWeight: "bold",
          marginBottom: "24px",
          textAlign: "center",
          fontSize: "2rem",
        }}
      >
        Game #{gameInfo?._id?.slice(-6) || "123456"} - Bingo Card
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)", // 1 for header, 5 for numbers
          gap: "2px",
          backgroundColor: "#000",
          borderRadius: "10px",
          padding: "2px",
        }}
      >
        {/* Render rows with header letter on the left */}
        {card.map((row, rowIndex) => (
          <>
            {/* BINGO letter column */}
            <div
              key={`header-${rowIndex}`}
              style={{
                backgroundColor: "#8b5cf6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "60px",
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "white",
                borderRadius: rowIndex === 0
                  ? "8px 0 0 0"
                  : rowIndex === card.length - 1
                  ? "0 0 0 8px"
                  : "0",
              }}
            >
              {headers[rowIndex]}
            </div>

            {/* Card row data */}
            {row.map((cell, colIndex) => {
              const isMarked = cell.includes("-marked");
              const number = cell.replace("-marked", "");
              const isLastRow = rowIndex === card.length - 1;
              const isLastCol = colIndex === row.length - 1;

              let borderRadius = "0";
              if (isLastRow && isLastCol) {
                borderRadius = "0 0 8px 0";
              }

              return (
                <div
                  key={`${rowIndex}-${colIndex}`}
                  style={{
                    backgroundColor: isMarked ? "#67d6ed" : "#e2e8f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "60px",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    color: isMarked ? "#1a365d" : "#4a5568",
                    borderRadius: borderRadius,
                  }}
                >
                  {number}
                </div>
              );
            })}
          </>
        ))}
      </div>
    </div>
  );
};

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="70vh"
        sx={{
          background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[600]} 100%)`,
          borderRadius: "20px",
          margin: "20px",
        }}
      >
        <Avatar
          sx={{
            width: 80,
            height: 80,
            backgroundColor: colors.blueAccent[500],
            mb: 2,
            animation: "pulse 2s infinite",
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.1)" },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          <SportsEsports sx={{ fontSize: "2rem" }} />
        </Avatar>
        <Typography variant="h4" color={colors.grey[100]} mb={2}>
          Loading Your Games...
        </Typography>
        <LinearProgress
          sx={{
            width: "200px",
            borderRadius: "10px",
            backgroundColor: colors.grey[700],
            "& .MuiLinearProgress-bar": {
              backgroundColor: colors.blueAccent[500],
            },
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.primary[700]} 50%, ${colors.primary[900]} 100%)`,
        p: 3,
      }}
    >
      {/* Header */}
      <Paper
        elevation={20}
        sx={{
          background: `linear-gradient(135deg, ${colors.blueAccent[800]} 0%, ${colors.blueAccent[600]} 100%)`,
          borderRadius: "20px",
          p: 3,
          mb: 4,
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 30% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)",
            pointerEvents: "none",
          },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            <Avatar
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                mr: 2,
                width: 60,
                height: 60,
              }}
            >
              <SportsEsports sx={{ fontSize: "2rem", color: "white" }} />
            </Avatar>
            <Box>
              <Typography
                variant="h2"
                sx={{
                  background: `linear-gradient(45deg, ${colors.grey[100]} 30%, #ffffff 90%)`,
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "bold",
                  mb: 1,
                }}
              >
                My Games
              </Typography>
              <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.8)" }}>
                Track your gaming journey and achievements
              </Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Badge
              badgeContent={totalGames}
              color="secondary"
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: colors.greenAccent[500],
                  color: "white",
                  fontWeight: "bold",
                },
              }}
            >
              <EmojiEvents sx={{ fontSize: "3rem", color: "white" }} />
            </Badge>
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.8)", mt: 1 }}
            >
              Total Games
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Games Grid */}
      {gamesList.length === 0 ? (
        <Paper
          elevation={10}
          sx={{
            background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[600]} 100%)`,
            borderRadius: "20px",
            p: 6,
            textAlign: "center",
          }}
        >
          <Avatar
            sx={{
              width: 100,
              height: 100,
              backgroundColor: colors.grey[600],
              mx: "auto",
              mb: 3,
            }}
          >
            <GamepadOutlined sx={{ fontSize: "3rem" }} />
          </Avatar>
          <Typography variant="h4" color={colors.grey[100]} mb={2}>
            No Games Found
          </Typography>
          <Typography variant="h6" color={colors.grey[300]} mb={3}>
            You haven't participated in any games yet
          </Typography>
          <IconButton
            onClick={() => {
              dispatch(resetGames());
              if (user?.id) {
                dispatch(listUserGames(user.id));
              }
            }}
            sx={{
              backgroundColor: colors.blueAccent[500],
              color: "white",
              "&:hover": {
                backgroundColor: colors.blueAccent[400],
                transform: "scale(1.1)",
              },
            }}
          >
            <Refresh />
          </IconButton>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {gamesList.map((game, index) => (
            <Grid item xs={12} md={6} lg={4} key={game._id || index}>
              <Card
                elevation={15}
                sx={{
                  background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[600]} 100%)`,
                  borderRadius: "20px",
                  position: "relative",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px) scale(1.02)",
                    boxShadow: `0 20px 40px rgba(0,0,0,0.3)`,
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: `linear-gradient(90deg, ${getStatusColor(
                      game.status
                    )} 0%, ${colors.blueAccent[500]} 100%)`,
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    mb={3}
                  >
                    <Box>
                      <Typography
                        variant="h5"
                        color={colors.grey[100]}
                        fontWeight="bold"
                        mb={1}
                      >
                        Game #{game._id?.slice(-6) || "Unknown"}
                      </Typography>
                      <Typography
                        variant="h6"
                        color={colors.blueAccent[300]}
                        mb={2}
                      >
                        By {game.organizer_name || "Unknown Organizer"}
                      </Typography>
                    </Box>
                    <Chip
                      icon={getStatusIcon(game.status)}
                      label={game.status?.toUpperCase() || "UNKNOWN"}
                      sx={{
                        backgroundColor: getStatusColor(game.status),
                        color: "white",
                        fontWeight: "bold",
                        "& .MuiChip-icon": {
                          color: "white !important",
                        },
                      }}
                    />
                  </Box>
                  <Divider
                    sx={{
                      backgroundColor: colors.grey[700],
                      mb: 3,
                      opacity: 0.3,
                    }}
                  />
                  <Box mb={3}>
                    <Box display="flex" alignItems="center" mb={2}>
                      <People sx={{ color: colors.greenAccent[400], mr: 2 }} />
                      <Box>
                        <Typography variant="body2" color={colors.grey[300]}>
                          Players
                        </Typography>
                        <Typography
                          variant="h6"
                          color={colors.grey[100]}
                          fontWeight="bold"
                        >
                          {game.users?.length || 0} Participants
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" mb={2}>
                      <CalendarToday
                        sx={{ color: colors.blueAccent[400], mr: 2 }}
                      />
                      <Box>
                        <Typography variant="body2" color={colors.grey[300]}>
                          Created
                        </Typography>
                        <Typography variant="body1" color={colors.grey[100]}>
                          {formatDate(game.createdAt)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Action Buttons */}
                  <Box display="flex" gap={2} mb={3}>
                    <Button
                      variant="contained"
                      startIcon={<ViewModule />}
                      onClick={(e) => handleViewCard(e, game)}
                      sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "white",
                        fontWeight: "bold",
                        borderRadius: "10px",
                        "&:hover": {
                          backgroundColor: colors.greenAccent[400],
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      View My Card
                    </Button>
                    <Button
                      variant="outlined"
                      component="a"
                      href={`https://mybingo.social/games/${game.organizer_name}?game_id=${game._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        borderColor: colors.blueAccent[400],
                        color: colors.blueAccent[400],
                        fontWeight: "bold",
                        borderRadius: "10px",
                        "&:hover": {
                          borderColor: colors.blueAccent[300],
                          color: colors.blueAccent[300],
                          backgroundColor: "rgba(255,255,255,0.05)",
                        },
                      }}
                    >
                      View Game
                    </Button>
                    <IconButton
                      href={`https://mybingo.social/game/called-numbers/${game.organizer_name}?game_id=${game._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="View Called Numbers"
                      sx={{
                        border: `1px solid ${colors.blueAccent[400]}`,
                        color: colors.blueAccent[400],
                        fontWeight: "bold",
                        borderRadius: "10px",
                        "&:hover": {
                          borderColor: colors.blueAccent[300],
                          color: colors.blueAccent[300],
                          backgroundColor: "rgba(255,255,255,0.05)",
                        },
                      }}
                    >
                      <FormatListNumbered />
                    </IconButton>
                  </Box>

                  {game.users && game.users.length > 0 && (
                    <Box>
                      <Typography
                        variant="body2"
                        color={colors.grey[300]}
                        mb={1}
                      >
                        Player IDs Preview:
                      </Typography>
                      <Box display="flex" flexWrap="wrap" gap={1}>
                        {game.users.slice(0, 3).map((userId, idx) => (
                          <Tooltip key={idx} title={userId}>
                            <Chip
                              size="small"
                              label={`...${userId.slice(-4)}`}
                              sx={{
                                backgroundColor: "rgba(255,255,255,0.1)",
                                color: colors.grey[200],
                                fontSize: "0.75rem",
                              }}
                            />
                          </Tooltip>
                        ))}
                        {game.users.length > 3 && (
                          <Chip
                            size="small"
                            label={`+${game.users.length - 3} more`}
                            sx={{
                              backgroundColor: colors.blueAccent[600],
                              color: "white",
                              fontSize: "0.75rem",
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Bingo Card Modal */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "600px",
              backgroundColor: colors.primary[500],
              borderRadius: "20px",
              boxShadow: 24,
              p: 4,
              outline: "none",
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={3}
            >
              <Typography
                variant="h4"
                color={colors.grey[100]}
                fontWeight="bold"
              >
                Your Bingo Card
              </Typography>
              <IconButton
                onClick={handleCloseModal}
                sx={{
                  backgroundColor: colors.redAccent[500],
                  color: "white",
                  "&:hover": {
                    backgroundColor: colors.redAccent[400],
                  },
                }}
              >
                <Close />
              </IconButton>
            </Box>
            {selectedGameCard && (
              <BingoCard
                card={selectedGameCard.card}
                gameInfo={selectedGameCard.game}
              />
            )}
          </Box>
        </Fade>
      </Modal>

      {gamesData && (
        <Paper
          elevation={5}
          sx={{
            background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[600]} 100%)`,
            borderRadius: "15px",
            p: 2,
            mt: 4,
            textAlign: "center",
          }}
        >
          <Typography color={colors.grey[100]}>
            Page {gamesData.pageNumber} • Showing {gamesList.length} of{" "}
            {totalGames} games
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default UserGames;
